import { defineMessages } from 'react-intl';

export default defineMessages({
  /** transactions table lables  */
  title: {
    id: 'features.wallet.title',
    defaultMessage: 'Dettaglio contratto N.',
    description: 'Title of wallet details',
  },
  transactionsTab: {
    id: 'features.wallet.transactionsTab',
    defaultMessage: 'Movimenti',
    description: 'Label for transactions tab',
  },
  pdfViewTab: {
    id: 'features.wallet.pdfViewTab',
    defaultMessage: 'Scheda Prodotto',
    description: 'Label for the tab that display the pdf of the product',
  },
  underlyingTab: {
    id: 'features.wallet.underlyingTab',
    defaultMessage: 'Sottostanti',
    description: 'Label for underlying tab',
  },
  underlyingCompaniesTab:{
    id: 'features.wallet.underlyingCompaniesTab',
    defaultMessage: 'Aziende Sottostanti',
    description: 'Label for underlying companies tab',
  },
  underlyingCompaniesNameLabel:{
    id: 'features.wallet.underlyingCompaniesNameLabel',
    defaultMessage: 'Nome',
    description: 'Label for name column underlying companies',
  },
  underlyingCompaniesDescriptionLabel:{
    id: 'features.wallet.underlyingCompaniesDescriptionLabel',
    defaultMessage: 'Descrizione',
    description: 'Label for description column underlying companies tab',
  },
  underlyingCompaniesAttachmentLabel:{
    id: 'features.wallet.underlyingCompaniesAttachmentLabel',
    defaultMessage: 'Allegato',
    description: 'Label for attachment column underlying companies tab',
  },
  underlyingCompaniesAttachmentText:{
    id: 'features.wallet.underlyingCompaniesAttachmentText',
    defaultMessage: 'Vedi Allegato',
    description: 'text for attachment row underlying companies tab',
  },
  totalAmount: {
    id: 'features.wallet.totalAmount',
    defaultMessage: 'Totale',
    description: 'label before the total amount in the underlying table',
  },
  detailTransactionsOperationDate: {
    id: 'features.wallet.detailTransactionsOperationDate',
    defaultMessage: 'Data operazione',
    description:
      'Label for the operation date column in the transactions table',
  },
  detailTransactionsSettlementDate: {
    id: 'features.wallet.detailTransactionsSettlementDate',
    defaultMessage: 'Data regolamento',
    description:
      'Label for the settlement date column in the transactions table',
  },
  detailTransactionsValueDate: {
    id: 'features.wallet.detailTransactionsValueDate',
    defaultMessage: 'Data valuta',
    description: 'Label for the value date column in the transactions table',
  },
  detailTransactionsCategory: {
    id: 'features.wallet.detailTransactionsCategory',
    defaultMessage: 'Categoria',
    description: 'Label for the category column in the transactions table',
  },
  detailTransactionsReason: {
    id: 'features.wallet.detailTransactionsReason',
    defaultMessage: 'Causale',
    description: 'Label for the reason column in the transactions table',
  },
  detailTransactionsAmounts: {
    id: 'features.wallet.detailTransactionsAmounts',
    defaultMessage: 'Importo regolato',
    description: 'Label for the amout column in the transactions table',
  },
  detailTransactionsFees: {
    id: 'features.wallet.detailTransactionsFees',
    defaultMessage: 'Commissioni',
    description: 'Label for the fees column in the transactions table',
  },
  detailTransactionsExpenses: {
    id: 'features.wallet.detailTransactionsCommission',
    defaultMessage: 'Spese fisse',
    description: 'Label for the expenses column in the transactions table',
  },
  detailTransactionsStamps: {
    id: 'features.wallet.detailTransactionsStamps',
    defaultMessage: 'Spese Bolli',
    description: 'Label for the expenses column in the transactions table',
  },
  detailTransactionsEquivalent: {
    id: 'features.wallet.detailTransactionsEquivalent',
    defaultMessage: 'Controvalore',
    description: 'Label for the Equivalent column in the transactions table',
  },
  detailTransactionsQuantity: {
    id: 'features.wallet.detailTransactionsQuantity',
    defaultMessage: 'Quantità',
    description: 'Label for the quantity column in the transactions table',
  },
  detailTransactionsPrice: {
    id: 'features.wallet.detailTransactionsPrice',
    defaultMessage: 'Prezzo',
    description: 'Label for the Price column in the transactions table',
  },
  detailTransactionsExchange: {
    id: 'features.wallet.detailTransactionsExchange',
    defaultMessage: 'Cambio',
    description: 'Label for the Exchange column in the transactions table',
  },
  detailTransactionsPriceCurrency: {
    id: 'features.wallet.detailTransactionsPriceCurrency',
    defaultMessage: 'Prezzo (Divisa)',
    description: 'Label for the PriceCurrency column in the transactions table',
  },
  detailTransactionsExchangeDate: {
    id: 'features.wallet.detailTransactionsExchangeDate',
    defaultMessage: 'Data cambio',
    description: 'Label for the ExchangeDate column in the transactions table',
  },
  /** underlying common table columns */
  detailUnderlyingAmount: {
    id: 'features.wallet.detailUnderlyingAmount',
    defaultMessage: 'Quantità',
    description: 'Label for the amount column in the underlying table',
  },
  detailUnderlyingMediumPrice: {
    id: 'features.wallet.detailUnderlyingMediumPrice',
    defaultMessage: 'Prezzo medio di carico',
    description: 'Label for the medium price column in the underlying table',
  },
  detailUnderlyingMarketPrice: {
    id: 'features.wallet.detailUnderlyingMarketPrice',
    defaultMessage: 'Prezzo di mercato',
    description: 'Label for the market price column in the underlying table',
  },
  detailUnderlyingMarketExchange: {
    id: 'features.wallet.detailUnderlyingMarketExchange',
    defaultMessage: 'Cambio di mercato',
    description: 'Label for the market exchange column in the underlying table',
  },
  detailUnderlyingCountervalue: {
    id: 'features.wallet.detailUnderlyingCountervalue',
    defaultMessage: 'Controvalore',
    description: 'Label for the countervalue column in the underlying table',
  },
  detailUnderlyingCountervalueAbbr: {
    id: 'features.wallet.detailUnderlyingCountervalueAbbr',
    defaultMessage: 'CTV €',
    description: 'Label for the countervalue column in the underlying table',
  },

  /** underlying managed funds table columns */
  detailUnderlyingProduct: {
    id: 'features.wallet.detailUnderlyingProduct',
    defaultMessage: 'Prodotto',
    description: 'Label for the product column in the underlying table',
  },
  detailUnderlyingMFMediumChange: {
    id: 'features.wallet.detailUnderlyingMFMediumChange',
    defaultMessage: 'Cambio medio di carico',
    description:
      'Label for the medium change column in the underlying managed funds table',
  },
  detailUnderlyingMFRate: {
    id: 'features.wallet.detailUnderlyingMFRate',
    defaultMessage: 'Rateo',
    description:
      'Label for the rate column in the underlying managed funds table',
  },
  detailUnderlyingMFPercentageIncrease: {
    id: 'features.wallet.detailUnderlyingMFPercentageIncrease',
    defaultMessage: '% Inc',
    description:
      'Label for the percentage increase column in the underlying managed funds table',
  },
  detailUnderlyingMFPercentageRiskCoefficient: {
    id: 'features.wallet.detailUnderlyingMFPercentageRiskCoefficient',
    defaultMessage: '% Coeff. rischio',
    description:
      'Label for the percentage risk coefficient column in the underlying managed funds table',
  },

  /** underlying unit linked table columns */
  detailUnderlyingULPercentage: {
    id: 'features.wallet.detailUnderlyingULPercentage',
    defaultMessage: 'Percentuale',
    description:
      'Label for the percentage column in the underlying unit linked table',
  },
  detailUnderlyingULMarketPriceDate: {
    id: 'features.wallet.detailUnderlyingULMarketPriceDate',
    defaultMessage: 'Data prezzo di mercato',
    description:
      'Label for the market price date in the underlying unit linked table',
  },
  noDataFound: {
    id: 'features.wallet.noData',
    defaultMessage: 'Nessun dato presente',
    description: 'Label for empty table',
  },
  kidTab: {
    id: 'features.wallet.kidTab',
    defaultMessage: 'KID',
    description: 'Label for KID tab',
  }
});
